<template>
  <div id="app">
    <Header></Header>
    <router-view v-bind:page-settings="pageSettings"></router-view>
    <Footer v-bind:page-settings="pageSettings"></Footer>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'

  let pageData = require('../config/testdaten')

  export default {
    name: 'app',
    components: {
      Header,
      Footer
    },
    data () {
      return {
        pageSettings: pageData.pageSettings,
        mainMenu: pageData.mainMenu
      }
    },
    beforeMount () {
      this.$store.dispatch('loadSettings')
      this.$store.dispatch('loadMenu')
      this.$store.dispatch('loadSubMenu')
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  @import './styles/custom-bootstrap.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>

<style lang="css">
  @import './styles/fontawesome.css';
  @import './styles/global.css';
</style>



// WEBPACK FOOTER //
// src/App.vue